__turbopack_context__.v({
  "actionsTwo": "WCall-module__h_kswG__actionsTwo",
  "avatar": "WCall-module__h_kswG__avatar",
  "backdrop": "WCall-module__h_kswG__backdrop",
  "btnSecondary": "WCall-module__h_kswG__btnSecondary",
  "bubble": "WCall-module__h_kswG__bubble",
  "close": "WCall-module__h_kswG__close",
  "ctaPrimary": "WCall-module__h_kswG__ctaPrimary",
  "fallback": "WCall-module__h_kswG__fallback",
  "floating": "WCall-module__h_kswG__floating",
  "form": "WCall-module__h_kswG__form",
  "formIntro": "WCall-module__h_kswG__formIntro",
  "formTitle": "WCall-module__h_kswG__formTitle",
  "modal": "WCall-module__h_kswG__modal",
  "modalClose": "WCall-module__h_kswG__modalClose",
  "rodo": "WCall-module__h_kswG__rodo",
  "text": "WCall-module__h_kswG__text",
  "title": "WCall-module__h_kswG__title",
  "twoCol": "WCall-module__h_kswG__twoCol",
  "wcall-slide-in": "WCall-module__h_kswG__wcall-slide-in",
});
